<template>
  <div class="flex h-16 w-full flex-col items-center justify-center px-4 py-2">
    <div class="text-center text-base font-normal leading-none tracking-wide text-zinc-800">
      <slot name="day"></slot>
    </div>
    <div class="">
      <slot name="icon"></slot>
    </div>
  </div>
</template>
